import React from 'react';
import Layout from '../components/Layout'
import ProductList from '../components/productList'
import {FilterProvider} from '../components/Context/filterContext' 

export default ({pageContext}) => {
  return (
    <Layout>
      <FilterProvider>
          <ProductList productTypeId={pageContext.id} productTypeLabel={pageContext.label}/>
      </FilterProvider>
    </Layout>
  )
}

